__turbopack_context__.v({
  "content": "ResizeableSidebar-module-scss-module__LvacFa__content",
  "left": "ResizeableSidebar-module-scss-module__LvacFa__left",
  "resizer": "ResizeableSidebar-module-scss-module__LvacFa__resizer",
  "right": "ResizeableSidebar-module-scss-module__LvacFa__right",
  "sidebar": "ResizeableSidebar-module-scss-module__LvacFa__sidebar",
});
